import { Expose, Type } from 'class-transformer'
import { ValidateNested } from 'class-validator'
import { Photo } from '../../entity'

export class PhotoDTO {
    @Expose()
    @ValidateNested()
    @Type(() => Photo)
    photo!: Photo
}
